import axios from 'axios';
import store from '../redux/store/store';
import { CC_API_BASE_URL, getCcRequestConfig } from '../config/ccApiConfig';
const API_INVOICEINTEGRATOR_URL = import.meta.env.VITE_API_URL;
const invoiceIntegratorService = {




//Market hesap bilgilerini getirir 
getInvoiceIntegratorAccountsApi: (userId,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.get(`${API_INVOICEINTEGRATOR_URL}/InvoiceIntegratorSetting?UserId=${userId}`,{
    headers: {
      Authorization: `Bearer ${userToken}`},
    });
},

getInvoiceIntegratorApi: async (token) => {
  try {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const response = await axios.get(`/InvoiceIntegrator`,{ headers: {
      Authorization: `Bearer ${userToken}`},
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices:', error);
    throw error;
  }
},
getInvoiceIntegratorApiCC: () => {
  return axios.get(`${CC_API_BASE_URL}/InvoiceIntegrator`, getCcRequestConfig());
},
addInvoiceIntegratorApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.InvoiceIntegratorData.map((item) => ({
    UserId: item.appUserId,
    integratorId: item.InvoiceIntegratorId,
    ValueId: item.valueId,
    Value: item.value,
    IA:true
  }));
  return axios.post(
    `${API_INVOICEINTEGRATOR_URL}/InvoiceIntegratorSetting/CreateRange`, 
    postData,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
},

updateInvoiceIntegratorApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  const postData = data.InvoiceIntegratorData.map((item) => ({
    UserId: item.appUserId,
    integratorId: item.InvoiceIntegratorId,
    ValueId: item.valueId,
    Value: item.value,
    IA:true,
    id:item.id
  }));
 
  return axios.put(`${API_INVOICEINTEGRATOR_URL}/InvoiceIntegratorSetting/UpdateRange`, postData,{
    headers: {
      Authorization: `Bearer ${userToken}`,},
    });
},
};




export default invoiceIntegratorService;
